import { render, staticRenderFns } from "./CloseClaimButton.vue?vue&type=template&id=25e7f65b"
import script from "./CloseClaimButton.vue?vue&type=script&lang=ts"
export * from "./CloseClaimButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports